<template>
  <div class="bg-main-repeat" :class="{ iframe_cover: gameUrlFromStore }">
    <div class="wrap-champion bg-championship bg-main-repeat">
      <div class="container">
        <header>
          <div class="title-main">
            <img :src="getThemeImagePath('title-championship.png')" alt="">
          </div>
        </header>
        <div class="d-flex align-items-center justify-content-center">
          <h3 class="title-secondary">
            夢の賞品が待っている！
          </h3>
        </div>
        <div class="games-wrap m-bottom">
          <div v-for="(game, key) in games" :key="key" class="games-btn" @click="openGame(game)">
            <a>
              <d-img :src="game" :alt="game.name" /></a>
          </div>
        </div>
        <p class="text-center text-secondary m-bottom">
          イベント終了時間：{{ endAt }}
        </p>
        <p class="text-center text-secondary text-color-primary m-bottom">
          <b>ゲームをプレイするには画像をクリックして</b>
        </p>

        <div class="award-frame m-bottom">
          <div class="circular-border circular-lt">
            <span class="circular-inner" />
          </div>

          <div class="circular-border circular-rt">
            <span class="circular-inner" />
          </div>

          <div class="circular-border circular-lb">
            <span class="circular-inner" />
          </div>

          <div class="circular-border circular-rb">
            <span class="circular-inner" />
          </div>

          <div class="award-title text-center">
            合計ボーナス
          </div>
          <div class="award-bonus text-center">
            <h1>{{ $store.state.brand.currency }} {{ totalPrize | numberFormat }}</h1>
          </div>
        </div>

        <div class="box-frame m-bottom">
          <div v-if="$store.getters.token" class="rank-box align-items-center m-bottom">
            <div class="icon-rank h-v-align-center" :class="getRankClass(memberInfo.rank-1)">
              <template v-if="memberInfo.rank > 0">
                {{ getRankLabel(memberInfo.rank-1) }}
                <img v-if="getRankImage(memberInfo.rank-1)" :src="getRankImage(memberInfo.rank-1)" alt="">
              </template>
              <template v-else>
                <img :src="getThemeImagePath('Ellipse.png')" alt="">
              </template>
            </div>
            <div class="user-i">
              <span class="user-id">{{ memberInfo.name }}</span>
              <span class="top-up">{{ memberInfo.performance | numberFormat }}</span>
            </div>
            <div v-if="$store.getters.token && memberInfo.rank <= bonus.length" class="d-flex align-items-center reward-number">
              {{ getBonus(memberInfo.rank-1) | numberFormat }}
            </div>
            <div v-else class="d-flex align-items-center reward-number text-gray">
              ———
            </div>
            <div class="icon-coin h-v-align-center">
              <img :src="getThemeImagePath('icon-coin.png')" alt="">
            </div>
          </div>
          <!-- rank-box End -->

          <h4 class="rank-title m-bottom">
            <span
              class="icon-crown"
            ><img :src="getThemeImagePath('icon-crown.png')" alt=""></span>ゲーム ランキング<span
              class="icon-crown"
            ><img
              :src="getThemeImagePath('icon-crown.png')"
              alt=""
            ></span>
          </h4>
          <!-- Rank Title -->

          <div v-for="(rank, key) in visibleRankList" :key="key" class="rank-list-frame">
            <div class="rank-box align-items-center">
              <div :class="getRankClass(key)" class="icon-rank h-v-align-center">
                {{ getRankLabel(key) }}
                <img v-if="getRankImage(key)" :src="getRankImage(key)" alt="">
              </div>
              <div class="user-i">
                <span class="user-id">{{ rank.name }}</span>
                <span class="top-up">{{ rank.amount | numberFormat }}</span>
              </div>
              <div v-if="key < bonus.length" class="d-flex align-items-center reward-number">
                {{ getBonus(key) | numberFormat }}
              </div>
              <div v-else class="d-flex align-items-center reward-number text-gray">
                ———
              </div>
              <div class="icon-coin h-v-align-center">
                <img :src="getThemeImagePath('icon-coin.png')" alt="">
              </div>
            </div>
          <!-- rank-box End -->
          </div>
          <!-- rank-list-frame End -->
          <button v-show="shouldShowMoreButton" id="rank-btn-more" class="btn btn-more" @click="showMore">
            もっと見る
          </button>
        </div>
        <!-- box-frame End -->

        <div class="box-frame m-bottom color-gray">
          <h5>注意事項</h5>
          <ol class="list-group" :class="{ active: isListActive }">
            <li>上位30名のプレイヤーに賞金総額50万円が贈られます。</li>
            <li>累計ベット額が1,000円以上で参加いただけます。</li>
            <li>プレイしたゲームの合計ベット額に基づいてポイントが付与されます。</li>
            <li>当チャンピオンシップに参加するには、過去に入金した履歴が必要となります。</li>
            <li>当チャンピオンシップのベット額の累計はKatsu現金ウォレットに計算されます。</li>
            <li v-show="isListActive">
              ボーナスは当チャンピオンシップ終了後24時間以内に、20倍の賭け条件のボーナスを、Katsuボーナスウォレットに配付いたします。
            </li>
            <li v-show="isListActive">
              ゲーム内にて、如何なる不正行為が発覚またはその疑いがあるとされたプレイヤーは、当チャンピオンシップの参加資格を失い、不正行為や一般利用規約および条件への違反が発覚した場合、当サイトは調査後に当該アカウントを制限、閉鎖、出金の規制をするなどの権利を留保いたします。
            </li>
            <li v-show="isListActive">
              <span class="hyperlink" @click="openNewTab('/page/terms')">
                「利用規約」</span>
              および
              <span class="hyperlink" @click="openNewTab('/page/rule')">
                「キャンペーン規約と条件」</span>が適用されます。
            </li>
            <li v-show="isListActive">
              ゲームランキングの更新に遅延がある可能性もございますので、ご留意くださいませ。
            </li>
          </ol>
          <button v-show="!isListActive" id="list-btn-more" class="btn btn-more" @click="toggleListActive">
            もっと見る
          </button>
        </div>
        <!-- list-frame End -->

        <div class="logo-katsuwin m-bottom">
          <img src="../../assets/theme_gold/images/stake-logo.png" alt="">
        </div>
        <div class="main-btn text-center" @click="goHome">
          <a
            class="btn btn-style-primary angle-rounded"
            href="javascript:;"
          >ホーム</a>
        </div>
      </div>
    <!-- container End -->
    </div>
    <!-- iframe Game -->
    <div v-show="gameUrlFromStore" class="iframe-background">
      <div v-show="gameUrlFromStore" class="overlay_bg bg-repeat bg-green">
        <button class="game_btn" @click="clearGameUrl">
          EXIT
        </button>
      </div>
      <iframe v-show="gameUrlFromStore" :src="gameUrlFromStore" class="iframe-content" />
    </div>
  </div>
</template>

<script>
import { getBetRankList, getPrizes, getEventQualification } from '@/api/event'
import { getGameList } from '@/api/game'
import dImg from '@/components/dynamicImg'
import { gameStart } from '@/utils/games'
import { showNotice, getThemeImagePath } from '@/utils/tool'

export default {
  name: 'Championship',
  components: {
    dImg
  },
  data() {
    return {
      eventId: '', // 錦標賽 event ID 列表
      prizes: [], // 錦標賽遊戲 ID
      games: [],
      rankList: [], // 排名
      bonus: [], // 獎金
      isListActive: false,
      isRankActive: false,
      displayCount: 6, // initial count to display,
      memberInfo: [],
      endAt: 0
    }
  },
  computed: {
    totalPrize() {
      return this.bonus.reduce((total, bonusItem) => {
        return total + parseInt(bonusItem.prize)
      }, 0)
    },
    visibleRankList() {
      const visibleList = this.rankList.slice(0, Math.min(this.displayCount, this.rankList.length))
      return visibleList
    },
    shouldShowMoreButton() {
      return this.displayCount < this.rankList.length
    },
    gameUrlFromStore() {
      return this.$store.state.app.gameUrl
    }
  },
  watch: {
    gameUrlFromStore(newVal) {
      const headerElement = document.querySelector('header')
      if (newVal) { // If the iframe is shown
        headerElement.style.display = 'none'
        this.disableScrolling()
      } else { // If the iframe is hidden
        this.enableScrolling()
        if (window.innerWidth < 992) {
          headerElement.style.display = 'block'
        } else {
          headerElement.style.display = 'none'
        }
      }
    }
  },
  created() {
    getBetRankList().then(response => {
      const eventArr = []
      response.data.event.forEach(item => {
        if (item.status === 1 && item.is_sys_disabled === 0) {
          eventArr.push(item)
        }
      })
      this.eventId = eventArr[0].id
      this.endAt = this.formatDate(eventArr[0].end_at * 1000)

      getPrizes({ token: this.$store.getters.token, event_id: this.eventId }).then(response => {
        const allowGames = response.data.allow_games
        this.prizes = allowGames.slice(0, 8)
        this.rankList = response.data.ranking
        if (this.$store.getters.token) {
          this.memberInfo['performance'] = response.data.performance
          this.rankList.some((item, index) => {
            if (item.member_id === this.$store.state.user.memberInfo.id) {
              this.memberInfo['name'] = item.name
              this.memberInfo['rank'] = index + 1
              return true
            }
            return false
          })

          if (this.memberInfo['rank'] === undefined) {
            this.memberInfo['name'] = this.memberName(this.$store.state.user.memberInfo.nickname)
            this.memberInfo['rank'] = -99
          }
        }

        this.bonus = response.data.prizes

        getGameList({ game_id_list_string: '[' + this.prizes + ']' }).then(response => {
          this.games = response.data.data
        })
      })
    })
  },
  mounted() {
    window.addEventListener('beforeunload', this.clearGameUrl)
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.clearGameUrl)
  },
  methods: {
    openGame(game) {
      if (this.$store.getters.token) {
        getEventQualification('bet_ranking').then(response => {
          const code = response.data.data.code
          if (code === 1001) {
            showNotice(this.$t('Bao.special_deposit_err6'))
          } else if (code === 2001 || code === 3001) {
            const message = this.$t('Bao.unavailible_3') + code + this.$t('Bao.unavailable_2')
            showNotice(message)
          } else if (code === 2101) {
            showNotice(this.$t('Bao.member_type_not_pass'))
          } else {
            this.$store.commit('SET_CHAMPIONSHIP_GAME', true)
            gameStart('game', game)
          }
        })
      } else {
        this.$store.commit('SET_CHAMPIONSHIP', true)
        window.open('/', '_blank')
      }
    },
    toggleListActive() {
      this.isListActive = !this.isListActive
    },
    goHome() {
      this.$store.commit('SET_CHAMPIONSHIP', true)
      const routeData = this.$router.resolve({ path: '/' })
      window.open(routeData.href, '_self')
    },
    getBonus(index) {
      if (index >= 0 && this.bonus[index]) {
        return this.bonus[index].prize !== undefined ? this.bonus[index].prize : 0
      }
      return 0
    },
    showMore() {
      this.displayCount += 5 // increase displayCount by 5
    },
    getRankClass(key) {
      if (key < 3) {
        return `r-pic r-${key + 1}st`
      }
      return 'h-v-align-center'
    },
    getRankLabel(key) {
      const labels = ['1st', '2nd', '3rd']
      return labels[key] || `${key + 1}`
    },
    getRankImage(key) {
      const images = [
        this.getThemeImagePath('rank-1st.png'),
        this.getThemeImagePath('rank-2nd.png'),
        this.getThemeImagePath('rank-3rd.png')
      ]
      return images[key]
    },
    formatDate(timestamp) {
      const date = new Date(timestamp)
      const year = date.getFullYear()
      const month = (date.getMonth() + 1).toString().padStart(2, '0')
      const day = date.getDate().toString().padStart(2, '0')
      const hours = date.getHours()
      const minutes = date.getMinutes().toString().padStart(2, '0')
      const ampm = hours >= 12 ? 'p.m.' : 'a.m.'
      const formattedHours = (hours % 12 === 0 ? 12 : hours % 12).toString().padStart(2, '0')

      return `${year}/${month}/${day} ${formattedHours}:${minutes} ${ampm}`
    },
    memberName(str) {
      if (str.length <= 2) {
        return str
      }

      const firstChar = str[0]
      const lastChar = str[str.length - 1]
      const maskedChars = '*'.repeat(str.length - 2)

      return `${firstChar}${maskedChars}${lastChar}`
    },
    clearGameUrl() {
      this.$store.commit('SET_GAME_URL', null)
      this.$store.commit('SET_CHAMPIONSHIP_GAME', false)
      this.$store.state.app.tempGameUrl = ''
    },
    disableScrolling() {
    // Disable scrolling
      document.body.style.overflow = 'hidden'
    },
    enableScrolling() {
    // Enable scrolling
      document.body.style.overflow = ''
    },
    openNewTab(route) {
      window.open(route, '_blank')
    },
    getThemeImagePath
  }
}
</script>
